// Homepage reviews — explicit Flickity init.
var Flickity = require( 'flickity' );

document.addEventListener( 'DOMContentLoaded', function () {
	var el = document.querySelector( '.homepage-reviews-carousel' );
	if ( ! el || el.classList.contains( 'flickity-enabled' ) ) {
		return;
	}
	new Flickity( el, {
		cellSelector:    '.review-card',
		cellAlign:       'left',
		contain:         true,
		pageDots:        false,
		prevNextButtons: true,
		wrapAround:      false,
		freeScroll:      true,
		imagesLoaded:    true
	} );
} );
